import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_BULK_COLLECTION_FILTERED = gql(`
  query FetchBulkCollectionFiltered(
    $handle: String!
    $selectedFilters: [CollectionItemFilterInput!]
    $after: String
    $logoScope: LogoScopeEnum = DTC
  ) {
    optimizedCollection(handle: $handle, colorScope: ALL) {
      id
      items(selectedFilters: $selectedFilters, grouping: PRODUCT_GROUP, after: $after) {
        nodes {
          id
          handle
          color
          embroidery(logoScope: $logoScope) {
            ...ProductEmbroidery
          }
          colorInfo {
            availability
            name
            rawName
            hexCodes
          }
          fit
          waitlistable
          shopifyId
          finalSale
          careInstructions
          collectionLinks {
            nodes {
              text
              href
            }
          }
          fitModel {
            description
            height
            images
            name
            pantsSize
            topSize
          }
          fitModelsDescriptions
          rawMaterials
          rtfFeatures
          images {
            nodes {
            color
            embroideryOffsets
            fit
            index
            source
            kind
            type
            }
          }
          priceRange
          rawFit
          productGroup {
            id
            briefProductDescription
            colorGroups {
              ...ColorGroup
            }
            defaultVariant {
              priceDetails {
                discountPrice {
                  amount
                }
                price {
                  amount
                }
              }
            }
            rawCategory
            rtfFeatures
            category
            description
            embroiderable
            fits
            genderCategory
            handle
            productsForAvailability: products {
              availableSizes
              colorInfo {
                rawName
              }
              rawFit
            }
            rawFits
            sizes
            style
            sizeChart: sizeChartCG {
              ...SizeChartFragment
            }
          }
          variants {
            color
            fit
            priceExplicitFmt
            discountPriceExplicitFmt
            priceDetails {
              discountPrice {
                amount
                currency
              }
              price {
                amount
                currency
              }
            }
            rawColor
            shopifyId
            size
            sku
            soldOut
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`)
